/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type FollowSearchButton_favoritesConnection$ref = any;
export type SbSharedFollowSearchProvider_user$ref = any;
export type SbSharedFollowSearchProvider_user = {
    readonly favorites: {
        readonly edges: ReadonlyArray<{
            readonly node: {
                readonly serviceId: string | null;
            } | null;
        } | null> | null;
        readonly " $fragmentRefs": FollowSearchButton_favoritesConnection$ref;
    } | null;
    readonly " $refType": SbSharedFollowSearchProvider_user$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "SbSharedFollowSearchProvider_user",
    "type": "User",
    "metadata": null,
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "followSearchTypes",
            "type": "[types]"
        },
        {
            "kind": "RootArgument",
            "name": "followSearchPages",
            "type": "[String]"
        }
    ],
    "selections": [
        {
            "kind": "LinkedField",
            "alias": null,
            "name": "favorites",
            "storageKey": null,
            "args": [
                {
                    "kind": "Literal",
                    "name": "first",
                    "value": 1
                },
                {
                    "kind": "Variable",
                    "name": "pages",
                    "variableName": "followSearchPages"
                },
                {
                    "kind": "Variable",
                    "name": "types",
                    "variableName": "followSearchTypes"
                }
            ],
            "concreteType": "favoritesConnection",
            "plural": false,
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "favoritesEdge",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "node",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Favorite",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "serviceId",
                                    "args": null,
                                    "storageKey": null
                                }
                            ]
                        }
                    ]
                },
                {
                    "kind": "FragmentSpread",
                    "name": "FollowSearchButton_favoritesConnection",
                    "args": null
                }
            ]
        }
    ]
} as any);
(node as any).hash = '0f3542953638ec77b442a0b69f6d09f2';
export default node;
